"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorPage = void 0;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const Container_1 = __importDefault(require("react-bootstrap/Container"));
const react_router_dom_1 = require("react-router-dom");
const ErrorPage = (props) => {
    var _a;
    const error = (0, react_router_dom_1.useRouteError)();
    console.error(error);
    function errorTemplate(title, message) {
        return (react_1.default.createElement(Container_1.default, { className: "error-page" },
            react_1.default.createElement(react_bootstrap_1.Row, { className: "justify-content-center" },
                react_1.default.createElement(react_bootstrap_1.Col, { lg: "8", className: "text-center my-5" },
                    react_1.default.createElement(react_router_dom_1.Link, { to: "/" },
                        react_1.default.createElement("img", { src: "/logo.svg" })),
                    react_1.default.createElement("h1", { className: "display-4 mt-4 mb-3" }, title),
                    message,
                    react_1.default.createElement(react_router_dom_1.Link, { to: "/", className: "btn btn-outline-dark mt-2" }, "\u2190 Zur Startseite")))));
    }
    if ((0, react_router_dom_1.isRouteErrorResponse)(error)) {
        if (error.status === 404) {
            return errorTemplate("404", react_1.default.createElement("p", null, "Die angeforderte Seite konnte nicht gefunden werden."));
        }
        return errorTemplate("Oops!", react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", null, "Sorry, ein unerwarteter Fehler ist aufgetreten."),
            ((_a = error.data) === null || _a === void 0 ? void 0 : _a.message) && (react_1.default.createElement("p", null,
                react_1.default.createElement("i", null, error.data.message)))));
    }
    else if (error instanceof Error) {
        return errorTemplate("Oops!", react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("p", null, "Sorry, ein unerwarteter Fehler ist aufgetreten."),
            react_1.default.createElement("div", { className: "alert alert-secondary", role: "alert" },
                react_1.default.createElement("i", null, error.message))));
    }
    else {
        return errorTemplate("Oops!", react_1.default.createElement("p", null, "Sorry, ein unerwarteter Fehler ist aufgetreten."));
    }
};
exports.ErrorPage = ErrorPage;
